





























































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Mutation, State, Getter, Action } from 'vuex-class';
import { DateTime } from 'luxon';
import { IProposal, ICompanyType, IEmployee, IUser } from '../../models';
import EditorTest from '../../components/UI/EditorTest.vue';
import { client } from '../../store';
import { BaseDetail } from '../Base/BaseDetail';
import { Watch } from 'vue-property-decorator';
import { getUserFullName } from '../../helpers/functions';
const namespace = 'proposal';
const ns = { namespace };

@Component({
  methods: {
    getUserFullName,
  },
  components: {
    UIEditor: () => import('@/components/UI/Editor.vue'),
    EditorTest,
  },
})
export default class ProposalDetail extends BaseDetail<IProposal> {
  namespace = namespace;
  modal = false;
  @State('currentUser', { namespace: 'user' }) user: IUser;
  @State('entities', ns) entities: Record<string, IProposal>;
  @State('entities', { namespace: 'employee' }) employees: Record<
    string,
    IEmployee
  >;
  @Action('getEntities', { namespace: 'employee' }) getEmployees: any;
  @Action('getEntity', ns) getEntity: any;
  @Action('createEntity', ns) createEntity: any;
  @Action('pushMessage', ns) pushMessage: any;
  @Action('updateEntity', ns) updateEntity: any;
  @Action('deleteEntity', ns) deleteEntity: any;
  input = '';
  mounted() {
    this.loadEntity();
  }
  beforeUpdate() {
    if (this.entityId && !Object.keys(this.entity).length) {
      this.loadEntity();
    }
  }
  getDate(date: string) {
    return DateTime.fromISO(date).toFormat('ff');
  }
  showModal() {
    this.modal = true;
  }
  get messages() {
    return this.entity?.chat?.messages?.slice().reverse() || [];
  }
  get disabledMessage() {
    return !this.input.length || this.input === '<p></p>';
  }
  attachToContractor(id: number) {
    client.post('/representatives/attach', {
      contractor_id: this.entity.contractor_id,
      representative_id: id,
    });
  }
  comment() {
    if (this.input && this.input !== '') {
      client
        .post(`/message`, {
          content: this.input,
          chat_id: this.entity?.chat?.id,
          creator_id: this.user.id,
        })
        .then(({ data }) => this.pushMessage({ id: this.entity.id, data }));

      this.input = '';
    }
  }
}
